/*
    🔥 PREFERENCIAS QUE SOBREVIVEN A LA RECARGA

    ⚠️ EL PROBLEMA QUE RESUELVE

    Cambiabas seis selectores en el panel, recargabas, y volvía todo al
    default. Probando estéticas eso se vuelve insoportable rápido.

    ⚠️ POR QUÉ NO GUARDAR SIEMPRE

    En desarrollo querés que se recuerde. En producción NO: si el
    usuario dejó guardado el nivel 7 con tipografía monoespaciada,
    y vos publicás un rediseño, ese usuario nunca lo ve.

    Por eso el guardado se controla desde APPLY_PLUGIN: se activa
    con el panel y se apaga junto con él.
*/

import { APP_STORAGE } from '../../../../_CORE/_RuntimeConfig/_Config/Acomodar/AppConfig.Storage.js';

const STORAGE_KEY = APP_STORAGE.APP_PREFERENCES;

export const onReadPreferences = () => {

    try {
        const RAW = window.localStorage.getItem(STORAGE_KEY);
        return RAW ? JSON.parse(RAW) : {};
    } catch {
        // Modo incógnito o storage lleno: seguimos sin preferencias
        return {};
    }
};

export const onSavePreference = (key, value) => {

    try {
        const CURRENT = onReadPreferences();
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...CURRENT, [key]: value }));
    } catch {
        // No romper la app por no poder guardar una preferencia
    }
};

export const onClearPreferences = () => {
    try { window.localStorage.removeItem(STORAGE_KEY); } catch { /* nada */ }
};

/*
    🔥 Resuelve el valor inicial de un eje

    Prioridad: lo guardado > lo configurado > el primero de la lista.
*/
export const onResolvePreference = (key, configValue, isEnabled = true) => {

    if (!isEnabled) return configValue;

    const SAVED = onReadPreferences()[key];

    return SAVED ?? configValue;
};

export const onSyncPreferencesBase = (config) => {

    try {
        const SIGNATURE = JSON.stringify(config);
        const CURRENT = onReadPreferences();

        if (CURRENT.__base === SIGNATURE) return false;

        window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ __base: SIGNATURE }));
        return true;
    } catch {
        return false;
    }
};
